/**
 * Where the back button on someone else's profile goes.
 *
 * `returnTo` is set by whatever opened the profile -- today the chat, which names the
 * conversation so it reopens instead of dropping the viewer on the chat list. It arrives
 * through history state, so it cannot come from a crafted link; the path check is defence
 * in depth, and matches the guard AuthCallbackPage applies to its ?next= parameter.
 *
 * `hasHistory` is false when this profile IS the first entry in the session -- a shared
 * profile link opened cold, or a push notification -- where going back would leave the
 * app. Those land on the viewer's own profile instead, which is a tab they can navigate
 * out of.
 *
 * Returns -1 for "pop one entry", which is what the other openers (volunteer cards, the
 * waiting list, profile search) want: back to wherever they were.
 */
export function profileBackTarget(returnTo: unknown, hasHistory: boolean): string | -1 {
  if (typeof returnTo === 'string' && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
    return returnTo;
  }
  return hasHistory ? -1 : '/profile';
}
